import { SocialProofAssets } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { getSocialProofAssetsById } from "./endpoints";

export function useGetSocialProofAssetsById<P, V>({
  id,
  refId,
}: {
  id?: string;
  refId?: string;
}): ReturnType<typeof useQuery<SocialProofAssets<P, V>>> {
  return useQuery({
    queryFn: () => getSocialProofAssetsById<P, V>({ id, refId }),
    queryKey: ["social-proof", id],
    retry: false,
  });
}
